var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.475 0.495609C11.925 0.945592 11.925 1.69563 11.475 2.14562L7.64999 5.9706L11.475 9.79559C11.925 10.2456 11.925 10.9956 11.475 11.4456C11.025 11.8956 10.275 11.8956 9.82497 11.4456L5.99998 7.62061L2.17499 11.4456C1.72501 11.8956 0.97497 11.8956 0.524987 11.4456C0.0750042 10.9956 0.0750042 10.2456 0.524987 9.79559L4.34997 5.9706L0.524987 2.14562C0.0750042 1.69563 0.0750042 0.945594 0.524987 0.495611C0.97497 0.0456282 1.72501 0.045628 2.17499 0.495611L5.99998 4.32059L9.82497 0.495609C10.275 0.0456266 11.0249 0.0456265 11.475 0.495609Z",
    className: "purple"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.6a1cb86a5a44974d4b8653682dda329f.svg";
export { ForwardRef as ReactComponent };